import { useSession } from '@/providers/session-provider';

export const securityClearance = (level: 'demo' | 'local') => {
  const hostname = window.location.hostname;
  if (level === 'local') {
    return hostname === 'localhost';
  }
  if (level === 'demo') {
    return hostname === 'demo.pigello.io' || hostname === 'localhost';
  }

  return false;
};

export const useEnvironment = () => {
  const {
    data: { user },
  } = useSession();
  const hostname = window.location.hostname;
  const env = process.env.NODE_ENV;
  const isDev = env === 'development';

  const isDemo = hostname === 'demo.pigello.io';
  const isProd = hostname === 'app.pigello.io';
  const isTestEnvironment = isDev || isDemo;

  const isPigelloUser =
    (user?.email?.endsWith('@pigello.se') && user?.emailVerified) ?? false;

  return {
    isProd,
    isDev,
    isDemo,
    isTestEnvironment,
    isPigelloUser,
  } as const;
};
